import { POIS_SERVICE } from "@/services/pois.service.js";

const state = {postPoiOutput: false, getPoisOutput: {}, putPoiOutput: false, deletePoiByIdOutput: false, getPoiByIdOutput: {}, getPoiBySlugOutput: {}};

const actions = {
    //Service to create pois
    postPoi({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postPoiRequest');

        POIS_SERVICE.postPoi(input)
            .then(
                output => {
                    commit('postPoiSuccess', output);
                },
                error => {
                    commit('postPoiFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated Pois
    getPois({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getPoisRequest');

        POIS_SERVICE.getPois(queryParams)
            .then(
                output => {
                    commit('getPoisSuccess', output);
                },
                error => {
                    commit('getPoisFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update Pois
    putPoi({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putPoiRequest');

        POIS_SERVICE.putPoi(input)
            .then(
                output => {
                    commit('putPoiSuccess', output);
                },
                error => {
                    commit('putPoiFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to remove pois
    deletePoiById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('deletePoiByIdRequest');

        POIS_SERVICE.deletePoiById(queryParams)
            .then(
                output => {
                    commit('deletePoiByIdSuccess', output);
                },
                error => {
                    commit('deletePoiByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get poi details
    getPoiById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getPoiByIdRequest');

        POIS_SERVICE.getPoiById(id)
            .then(
                output => {
                    commit('getPoiByIdSuccess', output);
                },
                error => {
                    commit('getPoiByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get poi details
    getPoiBySlug({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getPoiBySlugRequest');

        POIS_SERVICE.getPoiBySlug(queryParams)
            .then(
                output => {
                    commit('getPoiBySlugSuccess', output);
                },
                error => {
                    commit('getPoiBySlugFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postPoi
    postPoiRequest(state) {
        state.postPoiOutput = null;
    },
    postPoiSuccess(state, output) {
        state.postPoiOutput = true;
    },
    postPoiFailure(state) {
        state.postPoiOutput = false;
    },

    //getPois
    getPoisRequest(state) {
    },
    getPoisSuccess(state, output) {
        state.getPoisOutput = output;
    },
    getPoisFailure(state) {
        state.getPoisOutput = false;
    },

    //putPoi
    putPoiRequest(state) {
        state.putPoiOutput = null;
    },
    putPoiSuccess(state, output) {
        state.putPoiOutput = true;
    },
    putPoiFailure(state) {
        state.putPoiOutput = false;
    },

    //deletePoiById
    deletePoiByIdRequest(state) {
        state.deletePoiByIdOutput = null;
    },
    deletePoiByIdSuccess(state, output) {
        state.deletePoiByIdOutput = true;
    },
    deletePoiByIdFailure(state) {
        state.deletePoiByIdOutput = false;
    },

    //getPoiById
    getPoiByIdRequest(state) {
    },
    getPoiByIdSuccess(state, output) {
        state.getPoiByIdOutput = output;
    },
    getPoiByIdFailure(state) {
        state.getPoiByIdOutput = false;
    },

    //getPoiBySlug
    getPoiBySlugRequest(state) {
    },
    getPoiBySlugSuccess(state, output) {
        state.getPoiBySlugOutput = output;
    },
    getPoiBySlugFailure(state) {
        state.getPoiBySlugOutput = false;
    },
};

export const pois = {
    namespaced: true,
    state,
    actions,
    mutations
};